import { Map } from "immutable";

export const getGroups = (state) => state.departments.getIn(["departmentMap"], Map());
export const getFullGroups = (state) => state.departments.getIn(["groupsMap"], Map());
